import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { OPERATORS } from 'src/app/services/constants';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-agree',
  templateUrl: './agree.component.html',
  styleUrls: ['./agree.component.scss']
})
export class AgreeComponent {

  title = '';
  targetArea: any;
  currentUser: any;
  operator: any;
  order: any;
  OPERATORS: any;
  eulaPath: boolean;
  userType: string;
  sanitizedPdfUrl: SafeResourceUrl | null = null;
  rawUrl: any;
  siteUrl: any;
  safePdfUrl: SafeResourceUrl;

  constructor(
    public dialogRef: MatDialogRef<AgreeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public utilsService: UtilsService,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) {
    if (this.data?.type === 'terms') {
    const pdfUrl = '../../../assets/files/Eartheye-Terms-and-Conditions.pdf#toolbar=0&navpanes=0&scrollbar=0';
    this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
    } else {
    this.OPERATORS = OPERATORS;
    this.operator = data['operator'];
    this.currentUser = data['user'];
    if (this.operator?.operatorKey === OPERATORS.BLACKSKY) {
    let purpose = this.operator?.purpose?.purpose ? this.operator?.purpose.purpose : this.operator?.purpose
     if (purpose === 'Defence & Intelligence' || purpose === 'Maritime Security') {
      this.eulaPath = true;
     } else {
      this.eulaPath = false;
     }
    } else if (this.operator?.operatorKey === OPERATORS.AXELSPACE) {
      if (this.currentUser?.organisationType?.key === 'academia') {
       this.userType = 'academia';
      } else if (this.currentUser?.organisationType?.key === 'media') {
        this.userType = 'media';
      } else this.userType = 'others';
     }

     this.getEulaIntro();

     if (this.currentUser?.obfuscated) this.openObfuscatedEULAPdf();
     else this.openEULAPdf();
    }
  }


  onKeyPress(e: any, option: number) {
    let result: any = undefined;
    if (option == 1) result = ' Ok';
    this.dialogRef.close(result);
  }

  goToEULA(url: string) {
    window.open(url, "_blank");
  }

  savePdf(operatorKey: any) {
    if (this.rawUrl.includes('/assets/files')) {
      this.http.get(this.rawUrl, { responseType: 'blob' }).subscribe((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank');
      });
    } else window.open(this.rawUrl, "_blank");
  }

  openEULAPdf() {
    let operatorKey = this.operator?.operatorKey;

     if (operatorKey === OPERATORS.BLACKSKY) {
      this.rawUrl = this.eulaPath
        ? this.utilsService.getPdfUrl(operatorKey)
        : this.utilsService.getPdfUrl('BlackSky-Commercial');
    } else if (operatorKey === OPERATORS.AXELSPACE) {
      if (this.userType === 'academia') {
        this.rawUrl = this.utilsService.getPdfUrl('AxelSpace-Academic');
      } else if (this.userType === 'media') {
        this.rawUrl = this.utilsService.getPdfUrl('AxelSpace-Media');
      } else {
        this.rawUrl = this.utilsService.getPdfUrl('AxelSpace-Common');
      }
    } else {
      this.rawUrl = this.utilsService.getPdfUrl(operatorKey);
    }

    if (this.rawUrl) {
      this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.rawUrl}#toolbar=0&navpanes=0&scrollbar=0`);
    } else {
      this.sanitizedPdfUrl = null;
    }
  }

  openObfuscatedEULAPdf() {
    if (this.operator.operatorKey === OPERATORS.ESPER) {
     this.rawUrl = 'https://creativecommons.org/licenses/by/4.0/legalcode.en/';
    } else if (this.operator.operatorKey === OPERATORS.BLACKSKY) {
      this.rawUrl = this.eulaPath
        ? '../../../assets/files/EULA/EULA-Obfuscated/' + `${this.operator.obfuscateName}` + '.pdf'
        : '../../../assets/files/EULA/EULA-Obfuscated/' + `${this.operator.obfuscateName}` + '-Commercial.pdf';
    } else if (this.operator.operatorKey === OPERATORS.AXELSPACE) {      
      if (this.userType === 'academia') {
        this.rawUrl = '../../../assets/files/EULA/EULA-Obfuscated/' + `${this.operator.obfuscateName}` + '-Academic.pdf';
      } else if (this.userType === 'media') {
        this.rawUrl = '../../../assets/files/EULA/EULA-Obfuscated/' + `${this.operator.obfuscateName}` + '-Media.pdf';
      } else {
        this.rawUrl = '../../../assets/files/EULA/EULA-Obfuscated/' + `${this.operator.obfuscateName}` + '-Common.pdf';
      }
    } else this.rawUrl = '../../../assets/files/EULA/EULA-Obfuscated/' + `${this.operator.obfuscateName}` + '.pdf';
    if (this.rawUrl) {
      this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.rawUrl}#toolbar=0&navpanes=0&scrollbar=0`);
    } else {
      this.sanitizedPdfUrl = null;
    }
  }

  getEulaIntro() {
    let operatorKey = this.operator?.operatorKey;
    if (operatorKey === OPERATORS.BLACKSKY) {
      this.siteUrl = this.eulaPath
        ? this.utilsService.getEulaSiteUrl(operatorKey)
        : this.utilsService.getEulaSiteUrl('BlackSky-Commercial');
    } else if (operatorKey === OPERATORS.AXELSPACE) {
      if (this.userType === 'academia') {
        this.siteUrl = this.utilsService.getEulaSiteUrl('AxelSpace-Academic');
      } else if (this.userType === 'media') {
        this.siteUrl = this.utilsService.getEulaSiteUrl('AxelSpace-Media');
      } else {
        this.siteUrl = this.utilsService.getEulaSiteUrl('AxelSpace-Common');
      }
    } else {
      this.siteUrl = this.utilsService.getEulaSiteUrl(operatorKey);
    }
  }

   onNoClick(click): void {
    this.dialogRef.close(click);
  }

  saveTermPdf() {
    let pdfUrl = '../../../assets/files/Eartheye-Terms-and-Conditions.pdf';
    this.http.get(pdfUrl, { responseType: 'blob' }).subscribe((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    });
  }
  
}
